/*
* Pipeline Theme
*/

(function() {
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) { console.log(container); console.log(variant); }
  });
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) { console.log(cart); }
  });
  document.addEventListener('theme:cart:init', (e) => { console.log('theme:cart:init'); console.log(e); });
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });
})();

/* === BASYQS BODY | shared mega-menu hover panel (NEW / POPULAR / ALL) ===
   Finds nav items by POSITION and STRUCTURE, not by their label text, so
   renaming menu items — or building a whole new menu with different titles
   but the same "3 top-level items, one of them a mega-dropdown" shape —
   keeps this working with zero code changes. The mega-dropdown item is
   found structurally (it's whichever top-level item actually has a nested
   dropdown, via the theme's own `.grandparent` class); the other two
   top-level items become the two extra hover triggers, in whatever order
   they appear in the menu. (Same logic as the original BASYQS theme —
   unchanged here, since the top-level shape is still 3 items.) */
(function () {
  function init() {
    var nav = document.querySelector('.header__menu__inner');
    if (!nav || nav.dataset.basyqsHoverInit) return;
    nav.dataset.basyqsHoverInit = 'true';
    var topItems = Array.prototype.slice.call(nav.querySelectorAll(':scope > .menu__item'));

    var allItem = nav.querySelector('.menu__item.grandparent');
    if (!allItem) return;
    var otherItems = topItems.filter(function (it) { return it !== allItem; });
    var newItem = otherItems[0];
    var popularItem = otherItems[1];
    if (!newItem || !popularItem) return;

    var toggleKey = allItem.getAttribute('data-hover-disclosure-toggle');
    var panel = toggleKey ? document.getElementById(toggleKey) : allItem.querySelector('.header__dropdown');
    if (!panel) return;

    var group = [newItem, popularItem, allItem, panel];
    var hoverCount = 0;
    var closeTimer = null;
    var activeTrigger = null;

    function setActive(el) {
      group.forEach(function (g) {
        if (g.classList) g.classList.remove('is-menu-active');
      });
      if (el && el.classList) el.classList.add('is-menu-active');
      activeTrigger = el || null;
    }

    function relayDispatch(type) {
      var evt = new PointerEvent(type, { bubbles: false });
      evt.__basyqsRelay = true;
      allItem.dispatchEvent(evt);
    }

    function open(sourceEl) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (allItem.getAttribute('aria-expanded') !== 'true') { relayDispatch('pointerenter'); }
      setActive(sourceEl === panel ? activeTrigger || allItem : sourceEl);
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (hoverCount <= 0) {
          relayDispatch('pointerleave');
          setActive(null);
        }
      }, 350);
    }

    function isInGroup(node) {
      return !!node && group.some(function (g) {
        return g === node || (g.contains && g.contains(node));
      });
    }

    group.forEach(function (el) {
      el.addEventListener('pointerenter', function (e) {
        if (e.__basyqsRelay) return;
        hoverCount++;
        open(el);
      });
      el.addEventListener('pointerleave', function (e) {
        if (e.__basyqsRelay) return;
        if (isInGroup(e.relatedTarget)) return;
        hoverCount = Math.max(0, hoverCount - 1);
        scheduleClose();
      });
    });

    [newItem, popularItem].forEach(function (el) {
      var link = el.querySelector('[data-top-link]');
      if (!link) return;
      link.addEventListener('focus', function () { hoverCount++; open(el); });
      link.addEventListener('blur', function () { hoverCount = Math.max(0, hoverCount - 1); scheduleClose(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* === BASYQS BODY | mega-menu regroup (flex-based layout) ===
   This menu has family columns inside the mega-dropdown. Groups them by
   POSITION, not by label text: the first few family columns stack
   together in one narrow column on the left, every remaining family
   column becomes its own full-width standalone column. Rename any menu
   item's title, or swap in a new menu with the same shape, and this keeps
   working untouched.

   FIX (Sep 2026): until now this dropdown held 6 families — NEW, POPULAR,
   BASYQS BODY, SHOP, TOPS, BOTTOMS — with the first 3 (NEW/POPULAR/BASYQS
   BODY) stacked and the rest standalone, and BASYQS BODY (family index 2)
   was the one clickable heading in the stack. Per Annabelle's Sep 2026
   request, BASYQS BODY was promoted to its own top-level menu tab (see
   the BASYQS BODY MENU navigation), so it no longer lives inside this
   mega-dropdown at all — it's down to 5 families: NEW, POPULAR, SHOP,
   TOPS, BOTTOMS. STACK_COUNT was still hardcoded at 3, so it kept
   grabbing 3 families for the stack regardless of which ones they were —
   NEW, POPULAR, and now SHOP (the new 3rd family) — leaving only TOPS and
   BOTTOMS standalone instead of 3 full columns. That's what turned "4
   columns" into a lopsided 3. Lowered to 2, so only NEW + POPULAR stack
   (matching "families 1-3" minus the family that moved out) and SHOP,
   TOPS, BOTTOMS are each their own full column again — 1 stack + 3
   standalone = 4 columns, same as before BASYQS BODY moved out.
   CLICKABLE_HEADING_INDEX was BASYQS BODY's old position (index 2) inside
   this dropdown; since that family isn't here any more, there's no
   special clickable heading left — set to -1 (never matches) so every
   remaining family heading (NEW, POPULAR, SHOP, TOPS, BOTTOMS) is a
   section label only, same as all but one used to be. */
(function () {
  function initMegaGrid() {
    var allItem = document.querySelector('.menu__item.grandparent');
    if (!allItem) return;
    var inner = allItem.querySelector('.header__dropdown__inner');
    if (!inner || inner.dataset.basyqsGridInit) return;
    inner.dataset.basyqsGridInit = 'true';

    var families = Array.prototype.slice.call(inner.querySelectorAll(':scope > .dropdown__family'));

    var promo = Array.prototype.slice.call(inner.children).find(function (c) {
      return !c.classList.contains('dropdown__family');
    });
    if (promo) {
      promo.classList.add('basyqs-col-promo');
      var promoTitle = promo.querySelector('.hero__title');
      if (promoTitle && !promoTitle.dataset.basyqsSplit) {
        promoTitle.dataset.basyqsSplit = 'true';
        var titleText = promoTitle.textContent.trim();
        var words = titleText.split(/\s+/);
        if (words.length > 1) {
          var eyebrow = words[0];
          var headline = words.slice(1).join(' ');
          promoTitle.innerHTML =
            '<span class="basyqs-promo-eyebrow">' + eyebrow + '</span>' +
            '<span class="basyqs-promo-headline">' + headline + '</span>';
        }
      }
    }

    // First two family columns (whatever they're currently titled) stack
    // together in one narrow left-hand column — today: NEW, POPULAR.
    var STACK_COUNT = 2;
    if (families.length >= STACK_COUNT && !families[0].closest('.basyqs-group-stack')) {
      var groupStack = document.createElement('div');
      groupStack.className = 'basyqs-group-stack';
      inner.insertBefore(groupStack, families[0]);
      for (var s = 0; s < STACK_COUNT; s++) {
        families[s].classList.add('basyqs-col-stack-item');
        groupStack.appendChild(families[s]);
      }
    }

    // Every remaining family column stands on its own as a full column —
    // today: SHOP, TOPS, BOTTOMS.
    var restCols = families.slice(STACK_COUNT);
    restCols.forEach(function (col) {
      col.classList.add('basyqs-col-standalone');
    });

    // Every family heading is inert (label only, no navigation). There is
    // no clickable-heading exception any more now that BASYQS BODY has its
    // own top-level tab outside this dropdown — set to -1 so it never
    // matches any real family index.
    var CLICKABLE_HEADING_INDEX = -1;
    families.forEach(function (fam, i) {
      if (i === CLICKABLE_HEADING_INDEX) return;
      var heading = fam.querySelector(':scope > .navlink--child');
      if (!heading || heading.dataset.basyqsInert) return;
      heading.dataset.basyqsInert = 'true';
      heading.classList.add('basyqs-inert-heading');
      heading.setAttribute('aria-disabled', 'true');
      heading.setAttribute('tabindex', '-1');
      heading.addEventListener('click', function (e) { e.preventDefault(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaGrid);
  } else {
    initMegaGrid();
  }
})();

/* === BASYQS | Size Chart accordion === */
(function () {
  function initSizeChartRelay() {
    var triggers = document.querySelectorAll('[data-size-chart-trigger]');
    if (!triggers.length) return;
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        var nativeBtn = document.querySelector('.scr-open-size-chart');
        if (nativeBtn) { e.preventDefault(); e.stopPropagation(); nativeBtn.click(); }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChartRelay);
  } else {
    initSizeChartRelay();
  }
})();

/* === BASYQS | shrink product gallery + match left/right padding (desktop only) ===
   The gallery's height is a fixed ratio of its own width (the theme sets
   --default-ratio, e.g. "125.0%", once per product and locks every slide to
   that same height via the "flickity-lock-height" class), and at full column
   width that made the image render taller than the viewport on most desktop
   screens. The fix: measure the info column's own natural right-hand outer
   margin (it centers a fixed max-width content block inside itself, leaving
   a real gap to the screen edge) and apply that exact same amount as LEFT
   padding on .product__media__wrapper (right stays at 0, so the image's own
   right edge stays anchored to the center divider). That both shrinks the
   image (no cropping, ratio preserved) and makes the whitespace framing the
   image on the left match the whitespace framing the text on the right —
   real, exact left/right symmetry, which is the part that matters most here.
   A separate "fits above the fold" pad is still calculated as a fallback for
   when the info column can't be measured at all, but it no longer overrides
   the symmetry pad — on short windows the text column itself usually already
   runs past the fold anyway, so forcing the image even smaller than that
   bought nothing except breaking the left/right match. Mobile (<768px, the
   theme's own breakpoint for this side-by-side layout) is explicitly reset
   and left untouched. */
(function () {
  var BREAKPOINT = 768;
  var BUFFER = 32; // small breathing room below the fold

  function getWrapperAndGrid() {
    var wrapper = document.querySelector('.product__media__wrapper');
    var grid = document.querySelector('.product__grid.product__grid--slides');
    return wrapper && grid ? { wrapper: wrapper, grid: grid } : null;
  }

  function apply() {
    var refs = getWrapperAndGrid();
    if (!refs) return;
    var wrapper = refs.wrapper;
    var grid = refs.grid;

    if (window.innerWidth < BREAKPOINT) {
      wrapper.style.paddingLeft = '';
      wrapper.style.paddingRight = '';
      return;
    }

    var ratioStr = grid.style.getPropertyValue('--default-ratio') ||
      getComputedStyle(grid).getPropertyValue('--default-ratio');
    var ratio = parseFloat(ratioStr) / 100;
    if (!ratio) return;

    var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 70;
    var announceH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 0;
    var availableHeight = window.innerHeight - headerH - announceH - BUFFER;

    // Reset padding first so we measure the column's true full-bleed
    // width and position.
    wrapper.style.boxSizing = 'border-box';
    wrapper.style.paddingLeft = '0px';
    wrapper.style.paddingRight = '0px';
    var wrapperRect = wrapper.getBoundingClientRect();
    var fullWidth = wrapperRect.width;

    // Minimum left padding needed so the shrunk image's height fits above the fold.
    var neededWidth = availableHeight / ratio;
    var fitPad = neededWidth < fullWidth ? Math.max(0, fullWidth - neededWidth) : 0;

    // Padding needed so the image's outer-left gap (screen edge -> image)
    // matches the info column's own outer-right gap (text -> screen edge).
    // The info column centers a max-width content block inside itself, so
    // that gap is real theme layout, not something this script controls —
    // measure it live rather than guessing a fixed number.
    var symPad = null;
    var infoInner = document.querySelector('.product__inner') ||
      document.querySelector('.product__main__content .product__block__title');
    if (infoInner) {
      var infoRect = infoInner.getBoundingClientRect();
      var outerRightGap = window.innerWidth - infoRect.right;
      symPad = Math.max(0, outerRightGap - wrapperRect.left);
    }

    // Symmetry wins whenever we can measure it; the fold-fit pad is only a
    // fallback for the rare case the info column markup isn't found.
    var leftPad = symPad !== null ? symPad : fitPad;

    wrapper.style.paddingLeft = leftPad + 'px';
    wrapper.style.paddingRight = '0px';
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(apply, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', apply);
})();

/* ==========================================================================
   CART DRAWER REDESIGN (Sep 2026)
   Adapted from the basyqsbody.com cart drawer redesign. basyqs.com's own
   markup (Pipeline theme) uses the same hooks — .btn--add-to-cart,
   [data-product-add-popdown-wrapper], #drawer-cart,
   [data-drawer-toggle="drawer-cart"], [data-header-cart-count] — so this
   transfers directly. The Essential Upsell relocation step from the
   original build is intentionally left out: that app isn't installed on
   this store.
   - Shows a loading spinner on the Add to Cart button the instant it's
     clicked (native add-to-cart handling is left completely untouched —
     we never call preventDefault, so preorder/back-in-stock/etc apps keep
     working exactly as before).
   - Detects a successful add via the theme's own "Added to cart" popdown
     becoming visible, then opens the cart drawer and resets the button.
   - Keeps the header cart icon's quantity bubble in sync with the cart.
   ========================================================================== */
(function cartDrawerRedesign() {
  function qa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // --- 1) Loading state on the clicked Add to Cart button ---------------
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.tagName || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isProductForm = action.indexOf('/cart/add') !== -1 || form.hasAttribute('data-product-form') || form.classList.contains('product-form');
    if (!isProductForm) return;

    var btn = form.querySelector('.btn--add-to-cart, [data-add-to-cart], button[type="submit"][name="add"], button[type="submit"]');
    if (!btn) return;

    btn.classList.remove('atc-success');
    btn.classList.add('atc-loading');
    btn.dataset.atcLoadingSince = String(Date.now());
  }, true);

  // --- 2) Header cart quantity bubble + drawer title count ---------------
  function updateCartBubble() {
    var countEl = document.querySelector('[data-header-cart-count]');
    var count = countEl ? (parseInt(countEl.getAttribute('data-header-cart-count'), 10) || 0) : 0;
    qa('[data-cart-count-bubble]').forEach(function(bubble) {
      bubble.textContent = count;
      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', 'hidden');
      }
    });
    qa('[data-cart-drawer-count]').forEach(function(el) {
      el.textContent = '(' + count + ')';
    });
  }

  // Keep the bubble correct for ANY cart change (add, remove, qty edit),
  // by watching the attribute the theme's own cart-refresh code already
  // keeps up to date.
  function watchCartCountAttr() {
    qa('[data-header-cart-count]').forEach(function(el) {
      if (el.dataset.atcWatched) return;
      el.dataset.atcWatched = '1';
      new MutationObserver(updateCartBubble).observe(el, {
        attributes: true,
        attributeFilter: ['data-header-cart-count']
      });
    });
  }

  // --- 2b) Keep our new always-visible subtotal row in sync -------------
  // FIX (Sep 2026): the theme's own AJAX cart-refresh JS updates specific
  // known elements after an add/qty-change (e.g. [data-cart-final], the
  // checkout button's price), but has no idea our new
  // [data-cart-final-subtotal] row exists, so it was never touched and
  // kept showing whatever value was server-rendered on the very first page
  // load (often $0.00, from before anything was in the cart). Mirror the
  // checkout button's own total into our row instead of relying on a fresh
  // render.
  function syncSubtotalFromCheckoutButton() {
    var source = document.querySelector('[data-cart-final]');
    var target = document.querySelector('[data-cart-final-subtotal]');
    if (source && target) {
      target.textContent = source.textContent;
    }
  }
  function watchCheckoutTotal() {
    var source = document.querySelector('[data-cart-final]');
    if (!source || source.dataset.atcSubtotalWatched) return;
    source.dataset.atcSubtotalWatched = '1';
    new MutationObserver(syncSubtotalFromCheckoutButton).observe(source, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }
  // Any cart change the theme knows about (add, remove, qty edit) fires
  // this event — catch it here too, not just on the add-to-cart popdown,
  // so removes/qty edits keep the subtotal row correct as well.
  document.addEventListener('theme:cart:change', function () {
    syncSubtotalFromCheckoutButton();
    updateCartBubble();
  });

  // --- 3) Open the drawer + reset the button once the add succeeds ------
  function openCartDrawer() {
    var drawerEl = document.getElementById('drawer-cart');
    var alreadyOpen = drawerEl && drawerEl.classList.contains('drawer--visible');
    if (alreadyOpen) return;
    var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (toggle) toggle.click();
  }

  function clearLoadingButtons() {
    qa('.btn--add-to-cart.atc-loading').forEach(function(btn) {
      btn.classList.remove('atc-loading');
      btn.classList.add('atc-success');
      delete btn.dataset.atcLoadingSince;
      setTimeout(function() {
        btn.classList.remove('atc-success');
      }, 900);
    });
  }

  var addSeen = false;
  var popdownObserver = new MutationObserver(function() {
    var popdown = document.querySelector('[data-product-add-popdown-wrapper]');
    var hasContent = popdown && popdown.textContent.trim().length > 0;
    if (hasContent && !addSeen) {
      addSeen = true;
      updateCartBubble();
      syncSubtotalFromCheckoutButton();
      watchCheckoutTotal();
      openCartDrawer();
      clearLoadingButtons();
      setTimeout(function() { addSeen = false; }, 500);
    }
  });
  popdownObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

  // --- 4) Safety net: never leave a button stuck spinning ----------------
  setInterval(function() {
    qa('.btn--add-to-cart.atc-loading').forEach(function(btn) {
      var since = parseInt(btn.dataset.atcLoadingSince || '0', 10);
      if (since && Date.now() - since > 6000) {
        btn.classList.remove('atc-loading');
        delete btn.dataset.atcLoadingSince;
      }
    });
  }, 1000);

  // --- init ---------------------------------------------------------------
  function init() {
    updateCartBubble();
    watchCartCountAttr();
    syncSubtotalFromCheckoutButton();
    watchCheckoutTotal();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
